import MatchedContractsService from "@/api/services/matchedContracts";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
  },
  actions: {
    async fetchIndex({ commit }, { storeId, contractDistributionId, page = null, perPage = null, includes = [] } = {}) {
      const response = await MatchedContractsService.fetchIndex({
        storeId,
        contractDistributionId,
        page,
        perPage,
        includes,
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data.matchedContracts);
      return data;
    },
  },
};
